/* Listicle Orvova : barre de progression de lecture + barre d'achat mobile qui apparaît après la carte produit n°1. */
(function () {
  function init() {
    var root = document.getElementById('ovl');
    if (!root) return;
    var pg = document.getElementById('pg'), st = document.getElementById('st'), s1 = document.getElementById('s1');
    function update() {
      var h = document.documentElement, max = h.scrollHeight - h.clientHeight;
      if (pg) pg.style.width = (max > 0 ? (h.scrollTop || document.body.scrollTop) / max * 100 : 0) + '%';
      if (st && s1) st.classList.toggle('show', s1.getBoundingClientRect().top < 0);
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
